import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HeartPulse } from 'lucide-react';
export function SplashScreen() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gradient-to-b from-brand-primary to-brand-dark flex flex-col items-center justify-center p-6 text-white relative" data-id="element-1686">
      <motion.div initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="flex flex-col items-center flex-1 justify-center" data-id="element-1687">
        <div className="w-24 h-24 bg-white rounded-3xl flex items-center justify-center shadow-xl mb-6 relative overflow-hidden" data-id="element-1688">
          <HeartPulse size={48} className="text-brand-primary" data-id="element-1689" />
          <div className="absolute bottom-2 right-2 font-bold text-brand-primary text-xl" data-id="element-1690">
            W
          </div>
        </div>
        <h1 className="text-4xl font-bold mb-2 tracking-tight" data-id="element-1691">Whiz</h1>
        <p className="text-brand-light text-lg font-medium opacity-90" data-id="element-1692">
          Find trusted care near you.
        </p>
      </motion.div>

      <motion.div initial={{
      y: 50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.3,
      duration: 0.5
    }} className="w-full space-y-4 pb-8" data-id="element-1693">
        <button onClick={() => navigate('/onboarding')} className="w-full bg-white text-brand-primary font-semibold text-lg py-4 rounded-xl shadow-lg active:scale-[0.98] transition-transform" data-id="element-1694">
          Get Started
        </button>
        <button onClick={() => navigate('/signup', {
        state: {
          mode: 'signin'
        }
      })} className="w-full text-white font-medium text-lg py-4 active:opacity-70 transition-opacity" data-id="element-1695">
          Sign In
        </button>
      </motion.div>
    </div>;
}